import { createFeature, createReducer } from '@ngrx/store';

import { jobSummaryReducers } from './job-create-summary.reducer';
import { jobCreateSummaryInitialState } from './job-create-summary.state';

export const jobCreateSummaryFeature = createFeature({
  name: 'jobV3CreateSummary',
  reducer: createReducer(jobCreateSummaryInitialState, ...jobSummaryReducers),
});
